import { lock, unlock } from 'tua-body-scroll-lock';
import env from '../utils/env';

const HTML_CLASSLIST = document.documentElement.classList;

const ClassName = {
	NO_SCROLL: '_no-scroll',
};

class Scroll {
	disabled() {
		if (env.isIOS) {
			document.documentElement.style.overflow = 'hidden';
		} else {
			lock();

			const padRight = getComputedStyle(document.documentElement).paddingRight;
			document.documentElement.style.setProperty('--tua-pad-right', padRight);
		}

		HTML_CLASSLIST.add(ClassName.NO_SCROLL);
	}
	enabled() {
		if (env.isIOS) {
			document.documentElement.style.overflow = '';
		} else {
			unlock();
			document.documentElement.style.setProperty('--tua-pad-right', '');
		}

		HTML_CLASSLIST.remove(ClassName.NO_SCROLL);
	}
}

export default new Scroll();
